import React from "react";
import { Helmet } from "react-helmet-async";
import { inject } from "mobx-react";
import { sendMetriks } from "Services/sendMetriks";
import { generateUrl } from "Services/withDefaultParams";
import configRouters from "Configs/routes";
import { isMainSiteCode } from "Utils/siteConfig";
import WithSeoText from "Layouts/WithSeoText";
import DeclinationContainerNew from "Containers/DeclinationContainerNew";
import OuthomeBannerContainer from "Containers/OuthomeBannerContainer";
import { PaddingBottom } from "ComponentsUI/Spacings";
import OrdersHOC from "../OrdersHOC";
import ReviewsContainer from "./Containers/Reviews";
import ProvidersContainer from "./Containers/ProvidersContainer";
import FormWithBackground from "./Containers/FormWithBackground";

@inject("ApplicationModel")
export default class Page extends React.Component {
	componentDidMount() {
		sendMetriks("OPEN_ORDER_FORM");
	}

	canonical() {
		const {
			ApplicationModel: { siteConfig },
			match,
		} = this.props;

		let location = generateUrl(configRouters.OrderOuthome.route, {
			regionUrl: match.params.regionUrl,
		});

		return (
			<Helmet>
				<link
					rel="canonical"
					href={`${siteConfig.ssl === true ? `https` : "http"}://${
						siteConfig.domain_name_full
					}${location}`}
				/>
			</Helmet>
		);
	}

	render() {
		const {
			ApplicationModel: { siteCode, text },
			seoData,
		} = this.props;

		return (
			<>
				{this.canonical()}
				{isMainSiteCode(siteCode) && <div></div>}
				<WithSeoText seoData={seoData} text={text}>
					<OrdersHOC>
						<DeclinationContainerNew>
							<OuthomeBannerContainer
								h1Banner={seoData && seoData.h1}
								h1After={seoData && seoData.h1After}
							/>
						</DeclinationContainerNew>
						<ProvidersContainer />
						<PaddingBottom>
							<FormWithBackground />
						</PaddingBottom>
						<ReviewsContainer />
					</OrdersHOC>
				</WithSeoText>
			</>
		);
	}
}
